var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass:
        "relative block h-10.5 w-10.5 rounded-full focus:outline-none bg-grey overflow-hidden",
      on: {
        mouseover: function ($event) {
          return _vm.$emit("change-colour", _vm.colour)
        },
      },
    },
    [
      _c("span", {
        staticClass:
          "absolute inset-0 z-20 border border-transparent transition duration-300 rounded-full",
        class: {
          "border-black":
            _vm.selectedColour && _vm.colour.id === _vm.selectedColour.id,
        },
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "relative w-full h-full object-cover z-10",
        attrs: { src: _vm.colour.thumbnail.url, alt: _vm.colour.title },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }